(function () {
  'use strict';

  if (window.FellinoraCreatorCarouselDuoLoaded) {
    return;
  }

  window.FellinoraCreatorCarouselDuoLoaded = true;

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function setDelays(section) {
    section.querySelectorAll('[data-fccd-stagger]').forEach(function (item) {
      var delay = Number(item.getAttribute('data-fccd-delay')) || 0;
      item.style.setProperty('--fccd-delay', delay + 'ms');
    });
  }

  function reveal(section) {
    if (reduceMotion.matches || !('IntersectionObserver' in window)) {
      section.classList.add('fccd-is-visible');
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) {
          return;
        }

        section.classList.add('fccd-is-visible');
        observer.unobserve(entry.target);
      });
    }, {
      threshold: 0.16
    });

    observer.observe(section);
  }

  function initCarousel(section) {
    var slides = Array.prototype.slice.call(section.querySelectorAll('[data-fccd-slide]'));
    var prev = section.querySelector('[data-fccd-prev]');
    var next = section.querySelector('[data-fccd-next]');
    var autoplayTimer = null;
    var currentIndex = 0;

    if (!slides.length) {
      return;
    }

    function paint(activeIndex, leavingIndex) {
      slides.forEach(function (slide, index) {
        slide.classList.remove('is-active');
        slide.classList.remove('is-leaving');

        if (index === activeIndex) {
          slide.classList.add('is-active');
        } else if (index === leavingIndex) {
          slide.classList.add('is-leaving');
        }
      });
    }

    function goTo(index) {
      var normalized = (index + slides.length) % slides.length;
      var previous = currentIndex;
      currentIndex = normalized;
      paint(currentIndex, previous === currentIndex ? -1 : previous);
    }

    function stopAutoplay() {
      if (autoplayTimer) {
        window.clearInterval(autoplayTimer);
        autoplayTimer = null;
      }
    }

    function startAutoplay() {
      if (reduceMotion.matches || slides.length < 2) {
        return;
      }

      stopAutoplay();
      autoplayTimer = window.setInterval(function () {
        goTo(currentIndex + 1);
      }, 4200);
    }

    if (slides.length === 1) {
      paint(0, -1);
      if (prev) prev.disabled = true;
      if (next) next.disabled = true;
      return;
    }

    if (prev && next) {
      prev.addEventListener('click', function () {
        goTo(currentIndex - 1);
        startAutoplay();
      });

      next.addEventListener('click', function () {
        goTo(currentIndex + 1);
        startAutoplay();
      });
    }

    section.addEventListener('mouseenter', stopAutoplay);
    section.addEventListener('mouseleave', startAutoplay);
    section.addEventListener('focusin', stopAutoplay);
    section.addEventListener('focusout', function () {
      window.setTimeout(function () {
        if (!section.contains(document.activeElement)) {
          startAutoplay();
        }
      }, 0);
    });

    paint(0, -1);
    startAutoplay();
  }

  function initSection(section) {
    if (!section) {
      return;
    }

    setDelays(section);
    reveal(section);
    initCarousel(section);
  }

  function init(root) {
    (root || document).querySelectorAll('[data-fccd-section]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    }, { once: true });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
